<div class="modal-header">
    <span *ngIf="!file" class="modal-header-title">{{ 'FILES.SETTING_ADD_FILE_CATEGORIES' | translate }}</span>
    <!-- <span *ngIf="attrId" class="modal-header-title">Редактирование атрибута</span> -->
    <!-- <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss(false)">
        <svg-icon  src="/assets/images/icons/close.svg" [stretch]="true"
        [svgStyle]="{'width.px':20, 'height.px':20}"></svg-icon>
    </button> -->
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss(false)">
        <svg-icon  src="/assets/images/icons/close.svg" [stretch]="true"
        [svgStyle]="{'width.px':20, 'height.px':20}"></svg-icon>
    </button>
</div>

<div class="modal-body">

    <form class="form" #f="ngForm" [formGroup]="form" autocomplete="off">
        
        <div class="row">

            <div class="col-12">
                <div class="form-group">
                    <div class="form-group">
                        <label class="filter-label" for="category"> {{ 'CATEGORIES' | translate }}:</label>
                        <ng-select id="category"
                         class="custom" 
                         clearAllText="{{ 'CLEAR' | translate }}"
                         notFoundText="{{ 'NO_DATA' | translate }}" 
                         bindLabel="name" bindValue="id"
                         formControlName="category_id"
                         [multiple]="false" [closeOnSelect]="true"
                         [items]="categories" appendTo="body">
                            <!-- <ng-template ng-option-tmp let-item="item" let-item$="item$"
                                let-index="index">
                                <input id="item-{{index}}" type="checkbox"
                                    [checked]="item$.selected" />&nbsp;
                                <span>{{item.name}}</span>
                            </ng-template> -->
                        </ng-select>
                    </div>
                </div>
            </div>   

        </div>
    </form>
</div>
<div class="modal-footer btn-box">
    <button type="button" class="btn btn-light btn-back" (click)="activeModal.dismiss(false)">
        {{ 'CLOSE' | translate}}
    </button>
    <button  type="button" class="btn btn-primary btn-create" (click)="onCreate()"     [disabled]="form.invalid">{{ 'SAVE'| translate}}</button>
    <!-- <button *ngIf="attrId" type="button" class="btn btn-primary btn-sm"   (click)="onUpdate()"     [disabled]="form.invalid">{{ 'SAVE'| translate}}</button> -->
</div>